import React from 'react';
import { View } from '@/types/common';
import clsx from 'clsx';

import ViewToggler from '@/components/ViewToggler/ViewToggler';
import SectionSeperator from '@/components/SectionSeperator/SectionSeperator';
import GettingStartedInstructions from '@/components/GettingStartedInstructions/GettingStartedInstructions';

import styles from './TeacherSidebar.module.scss';
import logo from '@/assets/svg/logo_new.svg';
import logo60x60 from '@/assets/svg/logo_60x60.svg';
import AppIcon from '@/components/school-management/AppIcon/AppIcon';
import { t } from 'i18next';

interface TeacherSidebarProps {
  viewTabs: View[];
  emitSelectView: (view: View) => void;
  isCollapsed?: boolean;
  onToggleCollapse?: (collapsed: boolean) => void;
}

const TeacherSidebar = ({
  viewTabs,
  emitSelectView,
  isCollapsed = false,
  onToggleCollapse,
}: TeacherSidebarProps) => {
  return (
    <aside className={clsx(styles.sidebar, { [styles.collapsed]: isCollapsed })}>
      <div className={styles.header}>
        <img
          src={isCollapsed ? logo60x60 : logo}
          alt='Hello Britannica'
          className={clsx(styles.logo, { [styles.collapsed]: isCollapsed })}
        />

        <button
          className={clsx(styles.collapseButton, { [styles.collapsed]: isCollapsed })}
          onClick={() => onToggleCollapse?.(!isCollapsed)}
          aria-label={isCollapsed ? t('expandSidebar') || '' : t('collapseSidebar') || ''}
        >
          <AppIcon icon='expand' className={clsx(styles.collapseIcon)} />
        </button>
      </div>

      <div className={styles.menuSection}>
        <ViewToggler
          className={styles.viewToggler}
          viewTabs={viewTabs}
          emitSelectView={emitSelectView}
          isCollapsed={isCollapsed}
        />
      </div>
      <div className={styles.gettingStartedWrapper}>
        <GettingStartedInstructions isCollapsed={isCollapsed} />
      </div>
    </aside>
  );
};

export default TeacherSidebar;
